import { render, staticRenderFns } from "./MyColletionNewFile.vue?vue&type=template&id=83145316&scoped=true"
import script from "./MyColletionNewFile.vue?vue&type=script&lang=js"
export * from "./MyColletionNewFile.vue?vue&type=script&lang=js"
import style0 from "./MyColletionNewFile.vue?vue&type=style&index=0&id=83145316&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83145316",
  null
  
)

export default component.exports